module.exports = __webpack_public_path__ + "img/icon_3.b43ad9dc.svg";